var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.505,
    height: 62.505,
    viewBox: "0 0 62.505 62.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2598",
    "data-name": "Groupe 2598",
    transform: "translate(-782.574 -710.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2904",
    "data-name": "Trac\\xE9 2904",
    d: "M61.5,30.753A30.752,30.752,0,1,1,30.753,0,30.752,30.752,0,0,1,61.5,30.753",
    transform: "translate(783.074 711)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2905",
    "data-name": "Trac\\xE9 2905",
    d: "M137.213,115.357h7.258V98.615h5.361l1.072-6.763h-6.433V86.738c0-1.9,1.814-2.969,3.546-2.969h3.134V78.161l-5.608-.247c-5.361-.33-8.33,3.876-8.33,8.907v5.031h-6.1v6.763h6.1Z",
    transform: "translate(671.953 644.893)",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c8ca665e6c2348b4e1b6a0bdb1df8792.svg";
export { ForwardRef as ReactComponent };